import { useTranslation } from "react-i18next";
import { ButtonProps } from "@mui/material";
import { AppButton } from "../../../../shared/components/AppButton";
import styles from "./styles.module.css";

export const UndoChangesXmlBtn = ({ ...props }: ButtonProps) => {
  const { t } = useTranslation();
  return (
    <AppButton
      buttonType={"outlined"}
      className={styles["undo-changes-btn"]}
      {...props}
    >
      {t("schemas.undo_changes_xml")}
    </AppButton>
  );
};
